module.exports = __webpack_public_path__ + "static/millbrae-3c8b3cade137f1ab5fa10420638c29ca.jpg";